import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-854ae816"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "control-panl" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "file" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["ContrlPanl"], {
        group: $setup.ctrolGroup,
        show: true,
        modelValue: $setup.runs,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.runs) = $event)),
        onSelect: $setup.useSetting
      }, null, 8 /* PROPS */, ["group", "modelValue"])
    ]),
    ($setup.show && $setup.exixtsData)
      ? (_openBlock(), _createBlock($setup["Confirm"], {
          key: 0,
          title: _ctx.$t('dataset.joinTitle'),
          func: $setup.clickHandler
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", {
                class: "msg",
                innerHTML: _ctx.$t('dataset.joinTip')
              }, null, 8 /* PROPS */, _hoisted_2),
              _createVNode(_component_ui_input, {
                onSearchKeyUpdate: _cache[1] || (_cache[1] = u => ($setup.title = u)),
                type: "search",
                width: "360px",
                unplaceholder: _ctx.$t('sys.unSearchData'),
                options: $setup.selectOptions,
                modelValue: $setup.selectDataset,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectDataset) = $event)),
                placeholder: _ctx.$t('sys.selectPic'),
                ref: "selectRef",
                stopEl: "div"
              }, {
                option: _withCtx(({ raw, active }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["select-option", { active: raw.value.status === 1 }]),
                    onMousedown: ($event: any) => (raw.value.status === 1 && $setup.selectHandler(raw))
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, _toDisplayString(raw.value.name), 1 /* TEXT */),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('dataset.title')) + "：" + _toDisplayString(raw.value.sceneCode), 1 /* TEXT */)
                    ]),
                    (raw.value.status !== 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(raw.value.status === 3
                    ? _ctx.$t('dataset.exists')
                    : _ctx.$t('dataset.calc')), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_3)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["unplaceholder", "options", "modelValue", "placeholder"])
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_ui_button, {
              type: "submit",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clickHandler('no')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('sys.cancel')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_ui_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clickHandler('ok'))),
              disabled: !$setup.selectDataset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('dataset.joinBtn')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ui_input, {
        type: "file",
        maxSize: 10 * 1024 * 1024 * 1024,
        accept: ".ply,.las",
        toastErr: (type, info) => _ctx.$t(`sys.uploadErr.${type}`, info),
        ref: "fileRef",
        modelValue: $setup.file,
        "onUpdate:modelValue": $setup.uploadHandler
      }, null, 8 /* PROPS */, ["toastErr", "modelValue"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}